// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"_127GD"};